// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const AssetBrandTypeCodeService = {};

AssetBrandTypeCodeService.getAssetBrandTypeCodeList = function (userInput) {
  // console.log("🚀 ~ userInputgetAssetBrandTypeCodeList:", userInput);
  return lossClient({
    url: "/AssetBrandType/Items?pageSize=1000&pageIndex=0",
    method: "get",
  });
};

export default AssetBrandTypeCodeService;
